import Vue from 'vue'

const Auth = () => import('~/components/auth')
const Stepper = () => import('~/components/stepper')
const Location = () => import('~/components/location')

Vue.component('Auth', Auth)
Vue.component('Stepper', Stepper)
Vue.component('Location', Location)
